import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import { Link } from "react-router-dom"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import JDate from "jalali-date"
import Switch from "@material-ui/core/Switch"
import Snackbar from "@material-ui/core/Snackbar"
import * as constants from "../constants"
import Divider from "@material-ui/core/Divider"
import TableSortLabel from "@material-ui/core/TableSortLabel"
import Moment from "moment"
import NumberFormat from "react-number-format"
import HighlightOffIcon from "@material-ui/icons/HighlightOff"

import Collapse from "@material-ui/core/Collapse"
import Avatar from "@material-ui/core/Avatar"

import "react-modern-calendar-datepicker/lib/DatePicker.css"
import Calendar from "react-modern-calendar-datepicker"
import OutlinedInput from "@material-ui/core/OutlinedInput"
import IconButton from "@material-ui/core/IconButton"
import InputAdornment from "@material-ui/core/InputAdornment"
import FloatingLabelInput from "./FloatingLabelInput"
import Fab from "@material-ui/core/Fab"
import VoiceOverOffIcon from "@material-ui/icons/VoiceOverOff"
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver"
import CloseIcon from "@material-ui/icons/Close"
import CheckIcon from "@material-ui/icons/Check"
import Select from "react-select"

import ImageUploader from "react-images-upload"
import LinearProgress from "@material-ui/core/LinearProgress"
import { Lightbox } from "react-modal-image"

const styles = (theme) => ({
      paperrtl: {
            marginTop: theme.spacing(0),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      paper: {
            display: "flex",
            flexWrap: "wrap",
            "& > *": {
                  margin: theme.spacing(1),
                  width: theme.spacing(20),
            },
      },
      root: {
            width: "100%",
            margin: "15px",
            padding: "8px",
            direction: "rtl",
      },
      container: {
            maxHeight: 400,
      },
      large: {
            width: theme.spacing(10),
            height: theme.spacing(10),
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

class ChangeFieldDamagefile extends Component {
      cookies = new Cookies()
      temp333
      constructor(props) {
            super(props)
            this.state = {
                  redirect: false,
                  errstr: "",
                  errstatus: false,
                  okstatus: false,
                  requestinfos: [],
                  agentInfofilter: [],
                  rowsPerPage: 10,
                  page: 0,
                  fielddamagefile_id: "",
                  fielddamagefile: "",
                  fielddamagefile_fa: "",
                  fielddamagefile_link: "",
                  fielddamagefile_commission: "",
                  selectedTherapycontractConditionsCovarage: "",
                  optionTherapycontractConditionsCovarage: [],

                  fielddamagefile_desc: "",
                  fielddamagefile_mode: "1",
                  fielddamagefile_deactive: "1",
                  fielddamagefile_logo_url: "",
                  fielddamagefile_timage: "",
                  fielddamagefile_image: "",
                  orderBy: "fielddamagefile_id",
                  order: "desc",
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  newCompany: true,
                  logoCompany: "",
                  imageCompany: "",
                  loading: false,
                  percent: 0,

                  urlToLargeImageFile: "",
                  urlToHugeImageFile: "",
                  descImageFile: "",
                  openImageBox: false,
            }
      }

      setImageModel = (image, largimage, desc) => {
            this.setState({
                  urlToLargeImageFile: largimage,
                  urlToHugeImageFile: image,
                  descImageFile: desc,
                  openImageBox: true,
            })
      }

      closeLightbox = () => {
            this.setState({
                  openImageBox: false,
            })
      }

      handleChangeFieldDamagefileName = (event) => {
            this.setState({ fielddamagefile: event.target.value })
      }
      handleChangeFieldDamagefileId = (event) => {
            this.setState({ fielddamagefile_id: event.target.value })
      }

      onSelectLogoCompany = (picture) => {
            this.setState({
                  logoCompany: picture[0],
            })
      }

      handleTherapycontractConditionsCovarage = (selectedTherapycontractConditionsCovarage) => {
            this.setState({ selectedTherapycontractConditionsCovarage: selectedTherapycontractConditionsCovarage }, () => {
            })
      }

      onSelectImageCompany = (picture) => {
            this.setState({
                  imageCompany: picture[0],
            })
      }

      handleChangeFieldDamagefileDesc = (event) => {
            this.setState({ fielddamagefile_desc: event.target.value })
      }

      handleLevelof_prosperity = (event) => {
            this.setState({ fielddamagefile_fa: event.target.value })
      }

      handleTimeanswer_complaints = (event) => {
            this.setState({ fielddamagefile_link: event.target.value })
      }

      handleCommission = (event) => {
            this.setState({ fielddamagefile_commission: event.target.value })
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleChangeDeactive = (event) => {
            if (event.target.checked) {
                  this.setState({ fielddamagefile_deactive: "0" })
            } else {
                  this.setState({ fielddamagefile_deactive: "1" })
            }
      }

      handleChangeMode = (event) => {
            if (event.target.checked) {
                  this.setState({ fielddamagefile_mode: "0" })
            } else {
                  this.setState({ fielddamagefile_mode: "1" })
            }
      }

      handleCalculate = (selectedCalculate) => {
            this.setState({ selectedCalculate: selectedCalculate })
      }

      handleSelectRows = (row2) => {
            this.setState(
                  {
                        fielddamagefile_id: row2.fielddamagefile_id,
                        fielddamagefile: row2.fielddamagefile,
                        fielddamagefile_fa: row2.fielddamagefile_fa,
                        fielddamagefile_link: row2.fielddamagefile_link,
                        fielddamagefile_commission: row2.fielddamagefile_commission,
                        selectedTherapycontractConditionsCovarage: { value: row2.organ_therapycontract_conditions_covarage_id, label: row2.organ_therapycontract_conditions_covarage_name },

                        fielddamagefile_desc: row2.fielddamagefile_desc,
                        fielddamagefile_mode: row2.fielddamagefile_mode,
                        fielddamagefile_deactive: row2.fielddamagefile_deactive,
                        fielddamagefile_logo_url: row2.fielddamagefile_logo_url,
                        fielddamagefile_timage: row2.fielddamagefile_timage,
                        fielddamagefile_image: row2.fielddamagefile_image,
                        newCompany: false,
                  },
                  () => {}
            )
      }

      newCompany = (event) => {
            this.setState({
                  fielddamagefile_id: "",
                  fielddamagefile: "",
                  fielddamagefile_fa: "",
                  fielddamagefile_link: "",
                  fielddamagefile_commission: "",
                  fielddamagefile_desc: "",
                  fielddamagefile_mode: "0",
                  fielddamagefile_deactive: "0",
                  fielddamagefile_logo_url: "",
                  fielddamagefile_timage: "",
                  fielddamagefile_image: "",
                  TherapycontractConditionsCovarage: "",
                  newCompany: true,
            })
      }
      componentDidMount() {
            if (this.cookies.get("employee_token_str")) {
                  this.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.getCompany()
                                    self.getoptionTherapycontractConditionsCovarage()
                              } else if (arr.result === "error") {
                                    self.setState({ redirect: true })
                              }
                              self.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "checkemployeelogin")

                  xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ redirect: true })
            }
      }
      getoptionTherapycontractConditionsCovarage = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].organ_therapycontract_conditions_covarage_id, label: arr.data[k].organ_therapycontract_conditions_covarage_name })
                              }
                              self.setState({ optionTherapycontractConditionsCovarage: Company, selectedTherapycontractConditionsCovarage: Company[0] }, () => {
                              //      self.filterManagDiscount()
                              })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_organ_therapycontract_conditions_covarage")
            xhttp.open("POST", `${constants.BASE_URL}/therapy`)
            xhttp.send(fd)
      }

      getCompany() {
            this.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ requestinfos: arr.data, agentInfofilter: arr.data }, () => {})
                        } else if (arr.result === "error") {
                        }
                        self.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_fielddamagefile")

            xhttp.open("POST", `${constants.BASE_URL}/fielddamagefile`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      saveNewCompany = (logoCode, imageCode) => {
            const {
                  fielddamagefile_id,
                  fielddamagefile,
                  fielddamagefile_fa,
                  fielddamagefile_link,
                  fielddamagefile_commission,
                  fielddamagefile_desc,
                  fielddamagefile_mode,
                  fielddamagefile_deactive,
                  selectedTherapycontractConditionsCovarage
            } = this.state
            this.props.props.dispatch({
                  type: "WAITSHOW",
            })

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                              //self.setState({ redirect: true })
                              self.getCompany()
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "add_fielddamagefile")
            fd.append("fielddamagefile_id", fielddamagefile_id)
            fd.append("fielddamagefile", fielddamagefile)
            fd.append("fielddamagefile_fa", fielddamagefile_fa)
            fd.append("fielddamagefile_link", fielddamagefile_link)
            fd.append("fielddamagefile_commission", fielddamagefile_commission)
            fd.append("fielddamagefile_desc", fielddamagefile_desc)
            fd.append("fielddamagefile_logo_code", logoCode)
            fd.append("fielddamagefile_image_code", imageCode)
            fd.append("fielddamagefile_deactive", fielddamagefile_deactive)
            fd.append("fielddamagefile_mode", fielddamagefile_mode)
            fd.append("fielddamagefile_organ_therapycontract_conditions_covarage_id", selectedTherapycontractConditionsCovarage.value)

            console.log("logoCode" + logoCode)
            console.log("imageCode" + imageCode)
            xhttp.open("POST", `${constants.BASE_URL}/fielddamagefile`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      changeCompany = (logoCode, imageCode) => {
            const {
                  fielddamagefile_id,
                  fielddamagefile,
                  fielddamagefile_fa,
                  fielddamagefile_link,
                  fielddamagefile_commission,
                  fielddamagefile_desc,
                  fielddamagefile_mode,
                  fielddamagefile_deactive,
                  selectedTherapycontractConditionsCovarage
            } = this.state
            this.props.props.dispatch({
                  type: "WAITSHOW",
            })

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                              //self.setState({ redirect: true })
                              self.getCompany()
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "modify_fielddamagefile")
            fd.append("fielddamagefile_id", fielddamagefile_id)
            fd.append("fielddamagefile", fielddamagefile)
            fd.append("fielddamagefile_fa", fielddamagefile_fa)
            fd.append("fielddamagefile_link", fielddamagefile_link)
            fd.append("fielddamagefile_commission", fielddamagefile_commission)
            fd.append("fielddamagefile_desc", fielddamagefile_desc)
            fd.append("fielddamagefile_mode", fielddamagefile_mode)
            fd.append("fielddamagefile_deactive", fielddamagefile_deactive)
            fd.append("fielddamagefile_organ_therapycontract_conditions_covarage_id", selectedTherapycontractConditionsCovarage.value)

            if (imageCode !== "") {
                  fd.append("fielddamagefile_image_code", imageCode)
            }
            if (logoCode !== "") {
                  fd.append("fielddamagefile_logo_code", logoCode)
            }

            xhttp.open("POST", `${constants.BASE_URL}/fielddamagefile`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      uploadImageCompany = (mode, logoCompanyCode) => {
            const { imageCompany, fielddamagefile_fa } = this.state
            if (imageCompany && imageCompany !== "" && imageCompany !== null) {
                  this.setState({
                        loading: true,
                        percent: 0,
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({
                                          loading: false,
                                          percent: 0,
                                    })
                                    if (mode === "new") {
                                          self.saveNewCompany(logoCompanyCode, arr.data["image_code"])
                                    } else {
                                          self.changeCompany(logoCompanyCode, arr.data["image_code"])
                                    }
                              } else if (arr.result === "error") {
                              }
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "uploadpic")
                  fd.append("image", imageCompany)
                  fd.append("image_name", " تصویر فیلد خسارت درمان" + fielddamagefile_fa)
                  fd.append("image_desc", "تصویر فیلد خسارت درمان" + fielddamagefile_fa)
                  fd.append("name", "")
                  xhttp.upload.addEventListener(
                        "progress",
                        function(evt) {
                              if (evt.lengthComputable) {
                                    var percentComplete = evt.loaded / evt.total
                                    self.setState({
                                          percent: percentComplete * 100,
                                    })
                              }
                        },
                        false
                  )
                  xhttp.open("POST", `${constants.BASE_URL}/image`)
                  xhttp.send(fd)
            } else {
                  if (mode === "new") {
                        this.saveNewCompany(logoCompanyCode, "")
                  } else {
                        this.changeCompany(logoCompanyCode, "")
                  }
            }
      }

      uploadPicDelivery = (mode) => {
            const {
                  fielddamagefile_id,
                  fielddamagefile,
                  fielddamagefile_fa,
                  fielddamagefile_link,
                  fielddamagefile_commission,
                  fielddamagefile_desc,
                  fielddamagefile_deactive,
                  fielddamagefile_mode,
            } = this.state
            const { logoCompany } = this.state
            if (
                  fielddamagefile != "" &&
                  fielddamagefile_fa != "" &&
                  fielddamagefile_fa != "" &&
                  fielddamagefile != "" &&
                  fielddamagefile != ""
            ) {
                  if (logoCompany && logoCompany !== "" && logoCompany !== null) {
                        this.setState({
                              loading: true,
                              percent: 0,
                        })

                        var self = this
                        var xhttp = new XMLHttpRequest()
                        xhttp.onreadystatechange = function() {
                              if (this.readyState === 4 && this.status === 200) {
                                    var arr = JSON.parse(this.responseText)
                                    console.log(arr)
                                    if (arr.result === "ok") {
                                          self.setState({
                                                loading: false,
                                                percent: 0,
                                          })
                                          self.uploadImageCompany(mode, arr.data["image_code"])
                                    } else if (arr.result === "error") {
                                    }
                              }
                        }
                        var fd = new FormData()
                        fd.append("command", "uploadpic")
                        fd.append("image", logoCompany)
                        fd.append("image_name", " لوگوی فیلد خسارت درمان " + fielddamagefile_fa)
                        fd.append("image_desc", "لوگوی فیلد خسارت درمان" + fielddamagefile_fa)
                        fd.append("name", "")
                        xhttp.upload.addEventListener(
                              "progress",
                              function(evt) {
                                    if (evt.lengthComputable) {
                                          var percentComplete = evt.loaded / evt.total
                                          self.setState({
                                                percent: percentComplete * 100,
                                          })
                                    }
                              },
                              false
                        )
                        xhttp.open("POST", `${constants.BASE_URL}/image`)
                        xhttp.send(fd)
                  } else {
                        this.uploadImageCompany(mode, "")
                  }
            } else {
                  this.setState({ snackstr: "لطفا مشخصات شرکت را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      createSortHandler = (field) => {
            if (this.state.orderBy === field) {
                  if (this.state.order === "asc") {
                        this.setState({ order: "desc" })
                  } else {
                        this.setState({ order: "asc" })
                  }
            } else {
                  this.setState({ orderBy: field, order: "asc" })
            }
            var arraytemp = [],
                  i,
                  j,
                  temp,
                  a,
                  b
            arraytemp = this.state.agentInfofilter
            for (i = 0; i < arraytemp.length; i++) {
                  for (j = 0; j < arraytemp.length - 1; j++) {
                        a = arraytemp[j]
                        b = arraytemp[j + 1]
                        if (a[field] < b[field] && this.state.order === "asc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        } else if (a[field] > b[field] && this.state.order === "desc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        }
                  }
            }
      }

      handleChangeRowsPerPage = (event) => {
            this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 })
      }

      handleChangePage = (event, number) => {
            this.setState({ page: parseInt(number, 0) })
      }

      render() {
            const { classes } = this.props
            const {
                  urlToHugeImageFile,
                  descImageFile,
                  urlToLargeImageFile,
                  fielddamagefile_fa,
                  loading,
                  percent,
                  fielddamagefile_link,
                  fielddamagefile_commission,
                      optionTherapycontractConditionsCovarage,
                      selectedTherapycontractConditionsCovarage,

                  snackMode,
                  snackstr,
                  showSnack,
                  newCompany,
                  fielddamagefile_id,
                  fielddamagefile,
                  fielddamagefile_logo_url,
                  fielddamagefile_timage,
                  fielddamagefile_image,
                  fielddamagefile_desc,
                  fielddamagefile_mode,
                  fielddamagefile_deactive,
                  order,
                  orderBy,
                  okstatus,
                  errstr,
                  redirect,
                  agentInfofilter,
                  rowsPerPage,
                  page,
            } = this.state
            if (redirect) {
                  return <Redirect to="/" />
            } else {
                  return (
                        <div className={classes.paperrtl} dir="ltr">
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>
                              <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                          <Container component="main" maxWidth="lg">
                                                <Paper elevation={4} className={classes.root}>
                                                      <Grid container spacing={3}>
                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <img alt="" className={classes.large} src={fielddamagefile_logo_url} />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <img
                                                                              alt=""
                                                                              className={classes.large}
                                                                              src={fielddamagefile_timage}
                                                                              onClick={() => {
                                                                                    this.setImageModel(
                                                                                          fielddamagefile_timage,
                                                                                          fielddamagefile_image,
                                                                                          fielddamagefile_fa
                                                                                    )
                                                                              }}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <Typography align="center" variant="h7">
                                                                        <FloatingLabelInput
                                                                            disabled={true}
                                                                              placeholder="آی دی فیلد خسارت درمان "
                                                                              handleInputt={this.handleChangeFieldDamagefileId}
                                                                              value={fielddamagefile_id}
                                                                        />
                                                                  </Typography>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                        placeholder="نامک رشته"
                                                                        handleInputt={this.handleChangeFieldDamagefileName}
                                                                        value={fielddamagefile}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                        placeholder="نام فارسی رشته"
                                                                        handleInputt={this.handleLevelof_prosperity}
                                                                        value={fielddamagefile_fa}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={4}>
                                                                  <FloatingLabelInput
                                                                        placeholder="لینک خارجی "
                                                                        handleInputt={this.handleTimeanswer_complaints}
                                                                        value={fielddamagefile_link}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={4}>
                                                                  <FloatingLabelInput
                                                                        placeholder="درصد کارمزد"
                                                                        handleInputt={this.handleCommission}
                                                                        value={fielddamagefile_commission}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={4}>
                                                                  <div>
                                                                        <label className="on">{"زیر گروه"} </label>
                                                                        <Select
                                                                            isSearchable={true}
                                                                            className="adapter-txtsize"
                                                                            placeholder={"فیلد خسارت بیمه"}
                                                                            value={selectedTherapycontractConditionsCovarage}
                                                                            onChange={this.handleTherapycontractConditionsCovarage}
                                                                            options={optionTherapycontractConditionsCovarage}
                                                                        />
                                                                  </div>
                                                            </Grid>
                                                            <Grid item xs={12}>
                                                                  <FloatingLabelInput
                                                                        placeholder="توضیحات فیلد خسارت درمان "
                                                                        handleInputt={this.handleChangeFieldDamagefileDesc}
                                                                        value={fielddamagefile_desc}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={3}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <FormControlLabel
                                                                              control={
                                                                                    <Switch
                                                                                          checked={fielddamagefile_mode === "0" ? true : false}
                                                                                          onChange={this.handleChangeMode}
                                                                                          name="gilad"
                                                                                    />
                                                                              }
                                                                              label="وضعیت آنلاین بودن رشته"
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={3}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <FormControlLabel
                                                                              control={
                                                                                    <Switch
                                                                                          checked={fielddamagefile_deactive === "0" ? true : false}
                                                                                          onChange={this.handleChangeDeactive}
                                                                                          name="gilad"
                                                                                    />
                                                                              }
                                                                              label="وضعیت فیلد خسارت درمان "
                                                                        />
                                                                  </div>
                                                            </Grid>
                                                            <Grid item xs={3}>
                                                                  <ImageUploader
                                                                        withIcon={true}
                                                                        buttonText="لوگوی فیلد خسارت درمان را انتخاب نمایید"
                                                                        onChange={this.onSelectLogoCompany}
                                                                        withPreview="true"
                                                                        singleImage="true"
                                                                        imgExtension={[".jpg", ".jpeg", ".gif", ".png", ".gif", ".svg", ".tiff", ".webp", ".Lottie"]}
                                                                        maxFileSize={5242880}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={3}>
                                                                  <ImageUploader
                                                                        withIcon={true}
                                                                        buttonText="تصویر فیلد خسارت درمان را انتخاب نمایید"
                                                                        onChange={this.onSelectImageCompany}
                                                                        withPreview="true"
                                                                        singleImage="true"
                                                                        imgExtension={[".jpg", ".jpeg", ".gif", ".png", ".gif", ".svg", ".tiff", ".webp", ".Lottie"]}
                                                                        maxFileSize={5242880}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={12}>
                                                                  {loading && <LinearProgress variant="determinate" value={percent} />}
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                  {newCompany ? (
                                                                        <Button
                                                                              variant="outlined"
                                                                              color="primary"
                                                                              onClick={(e) => {
                                                                                    this.uploadPicDelivery("new")
                                                                              }}
                                                                        >
                                                                              {"ثبت فیلد خسارت درمان جدید "}
                                                                        </Button>
                                                                  ) : (
                                                                        <div style={{ width: "100%", textAlign: "right" }}>
                                                                              <Button variant="outlined" color="primary" onClick={this.newCompany}>
                                                                                    {"فیلد خسارت درمان جدید"}
                                                                              </Button>
                                                                              {"          "}
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={(e) => {
                                                                                          this.uploadPicDelivery("modify")
                                                                                    }}
                                                                              >
                                                                                    {"ثبت تغییرات"}
                                                                              </Button>
                                                                        </div>
                                                                  )}
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                  <Divider />
                                                            </Grid>
                                                      </Grid>
                                                </Paper>
                                          </Container>
                                    </Grid>
                                    <Grid item xs={12}>
                                          <Container maxWidth="lg">
                                                <Paper className={classes.root}>
                                                      <TableContainer dir="rtl">
                                                            <Table aria-label="sticky table">
                                                                  <TableHead>
                                                                        <TableRow>
                                                                              <TableCell></TableCell>

                                                                              <TableCell
                                                                                    key={"fielddamagefile_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                                    sortDirection={orderBy === "fielddamagefile_id" ? order : false}
                                                                              >
                                                                                    {"آیدی فیلد خسارت درمان"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "fielddamagefile_id"}
                                                                                          direction={orderBy === "fielddamagefile_id" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("fielddamagefile_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"fielddamagefile"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"نام رشته"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "fielddamagefile_fa"}
                                                                                          direction={orderBy === "fielddamagefile_fa" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("fielddamagefile_fa")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                              <TableCell
                                                                                  key={"fielddamagefile_fa"}
                                                                                  align={"center"}
                                                                                  style={{ minWidth: 20 }}
                                                                                  sortDirection={orderBy === "fielddamagefile_fa" ? order : false}
                                                                              >
                                                                                    {"زیر گروه"}
                                                                                    <TableSortLabel
                                                                                        active={orderBy === "organ_therapycontract_conditions_covarage_id"}
                                                                                        direction={orderBy === "organ_therapycontract_conditions_covarage_id" ? order : "asc"}
                                                                                        onClick={(e) => {
                                                                                              this.createSortHandler("organ_therapycontract_conditions_covarage_id")
                                                                                        }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"fielddamagefile_commission"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"درصد کارمزد"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "fielddamagefile_commission"}
                                                                                          direction={
                                                                                                orderBy === "fielddamagefile_commission"
                                                                                                      ? order
                                                                                                      : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("fielddamagefile_commission")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"fielddamagefile_desc"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {" توضیحات "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "fielddamagefile_desc"}
                                                                                          direction={
                                                                                                orderBy === "fielddamagefile_desc" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("fielddamagefile_desc")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"fielddamagefile_mode"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                              >
                                                                                    {"وضعیت رشته"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "fielddamagefile_mode"}
                                                                                          direction={
                                                                                                orderBy === "fielddamagefile_mode" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("fielddamagefile_mode")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"fielddamagefile_deactive"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                              >
                                                                                    {"وضعیت رشته"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "fielddamagefile_deactive"}
                                                                                          direction={
                                                                                                orderBy === "fielddamagefile_deactive" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("fielddamagefile_deactive")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                        </TableRow>
                                                                  </TableHead>

                                                                  <TableBody>
                                                                        {agentInfofilter
                                                                              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                              .map((row) => {
                                                                                    return (
                                                                                          <TableRow
                                                                                                hover
                                                                                                role="checkbox"
                                                                                                tabIndex={-1}
                                                                                                key={row["fielddamagefile_id"]}
                                                                                                value={row}
                                                                                                onClick={() => {
                                                                                                      this.handleSelectRows(row)
                                                                                                }}
                                                                                          >
                                                                                                <TableCell>
                                                                                                      <img
                                                                                                            className={classes.small}
                                                                                                            alt=""
                                                                                                            src={row["fielddamagefile_logo_url"]}
                                                                                                      />
                                                                                                </TableCell>
                                                                                                <TableCell key={"fielddamagefile_id"} align={"center"}>
                                                                                                      {row["fielddamagefile_id"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"fielddamagefile_fa"} align={"center"}>
                                                                                                      {row["fielddamagefile_fa"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"organ_therapycontract_conditions_covarage_id"} align={"center"}>
                                                                                                      {row["organ_therapycontract_conditions_covarage_name"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"fielddamagefile_commission"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["fielddamagefile_commission"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"fielddamagefile_desc"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["fielddamagefile_desc"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"fielddamagefile_mode"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["fielddamagefile_mode"] === "1" ||
                                                                                                      row["fielddamagefile_mode"] === 1 ? (
                                                                                                            <Fab variant="extended">
                                                                                                                  <VoiceOverOffIcon />
                                                                                                                  {"آفلاین"}
                                                                                                            </Fab>
                                                                                                      ) : (
                                                                                                            <Fab
                                                                                                                  variant="extended"
                                                                                                                  style={{ background: "#44b700" }}
                                                                                                            >
                                                                                                                  <RecordVoiceOverIcon />
                                                                                                                  {"آنلاین"}
                                                                                                            </Fab>
                                                                                                      )}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"fielddamagefile_deactive"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["fielddamagefile_deactive"] === "1" ||
                                                                                                      row["fielddamagefile_deactive"] === 1 ? (
                                                                                                            <Fab variant="extended">
                                                                                                                  <VoiceOverOffIcon />
                                                                                                                  {"غیر فعال"}
                                                                                                            </Fab>
                                                                                                      ) : (
                                                                                                            <Fab
                                                                                                                  variant="extended"
                                                                                                                  style={{ background: "#44b700" }}
                                                                                                            >
                                                                                                                  <RecordVoiceOverIcon />
                                                                                                                  {"فعال"}
                                                                                                            </Fab>
                                                                                                      )}
                                                                                                </TableCell>
                                                                                          </TableRow>
                                                                                    )
                                                                              })}
                                                                  </TableBody>
                                                            </Table>
                                                      </TableContainer>
                                                      <TablePagination
                                                            rowsPerPageOptions={[10, 25, 100]}
                                                            component="div"
                                                            count={agentInfofilter.length}
                                                            rowsPerPage={rowsPerPage}
                                                            page={page}
                                                            onChangePage={this.handleChangePage}
                                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                      />
                                                </Paper>
                                          </Container>
                                    </Grid>
                              </Grid>

                              {okstatus ? (
                                    <Alert severity="success">
                                          <AlertTitle>پیام</AlertTitle>
                                          {errstr}
                                    </Alert>
                              ) : null}

                              {this.state.openImageBox && (
                                    <Lightbox
                                          medium={urlToLargeImageFile}
                                          large={urlToHugeImageFile}
                                          alt={descImageFile}
                                          onClose={this.closeLightbox}
                                          showRotate={true}
                                          hideZoom={false}
                                    />
                              )}
                        </div>
                  )
            }
      }
}

export default withStyles(styles)(ChangeFieldDamagefile)
